<template>
    <Modal 
      v-model="val"
      :width="800"
    >
      <div v-if="val">
        <h2 class="mb-m">消費者網路投保需求聲明事項(KYC)</h2>
        <ol
          :style="{
            paddingLeft: '15px',
            fontSize: '14px',
            color: '#5D5E60'
          }"
        >
          <li 
            v-for="item in items"
            :key="item"
            :style="{lineHeight: '1.8'}"
            v-text="item"
          />
        </ol>
      </div>
    <div slot="footer" />
  </Modal>
</template>

<script>
  import { Modal } from 'iview';

  export default {
    components: { Modal },
    props: {
      value: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        items: [
          '我已正確提供投保所需之個人基本資料。',
          '我已瞭解所投保之商品之投保條件，符合我的投保條件、投保目的及需求。',
          '我已充分瞭解所交保費係用以購買保險商品。',
          '我已充分確認欲投保之險種、保額與保費支出與自身實際需求相當。',
          '我已瞭解投保之保險契約的權利行使、變更、解除及終止之方式。',
          '我已瞭解承保公司對於我投保之保險契約的權利、義務及責任。',
          '我已瞭解自身應負擔之保險費以及毋須負擔違約金及其他費用。',
          '我已瞭解我投保的保險契約受有保險安定基金之保障。',
          '我已瞭解承保公司因本商品所生紛爭之處理及申訴管道。',
          '我已評估自身收入、財務狀況、職業、健康狀況與保險費之負擔能力及保險金額的相當性。'
        ]
      };
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>